import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import {
  SET_ORDEN,
  ESTADO_ORDEN,
  ESTADO_ORDEN_FAIL,
  ESTADO_ORDEN_SUCCESS,
} from "../ActionTypes";

export const setOrden = (orden) => (dispatch) => {
  dispatch({ type: SET_ORDEN, payload: orden });
};

export const wsGetEstadoOrden =
  (idTurno, flgTiempoEspera, nextStep) => (dispatch) => {
    dispatch({ type: ESTADO_ORDEN });

    axiosAutoCheck().then((respuesta) => {
      respuesta
        .get(`/estadoOrden/${idTurno}/${flgTiempoEspera}`)
        .then((resp) => {
          dispatch({ type: ESTADO_ORDEN_SUCCESS, payload: resp.data });
          if (nextStep) nextStep(resp.data, true);
        })
        .catch((err) => {
          dispatch({ type: ESTADO_ORDEN_FAIL, payload: err?.response?.data });
          if (nextStep) nextStep(err, false);
        });
    });
  };
